import {removeCurrent} from "@main/helpers";

export class InputSelect {
    constructor(el) {
        this.el = el;
        this.items = [...this.el.querySelectorAll(".js-input-select-item")];
        this.input = this.el.querySelector(".js-input-select-input");
        this.valueInput = this.el.querySelector(".js-input-select-value");
        this.form = this.el.closest(".js-form-validate");
        this.initEvents();
    }

    initEvents() {
        this.el.addEventListener("click", () => {
            this.el.classList.toggle("opened");
        });

        this.items.forEach((item) => {
            item.addEventListener("click", () => {
                this.setItemSelected(item);
            });
        });

        this.el.addEventListener("setSelectedByValue", (e) => {
            this.setSelectedByValue(e.detail);
        });
    }

    setItemSelected(item) {
        if (!item.classList.contains("current")) {
            removeCurrent(this.items);
            item.classList.add("current");
            const prevVal = this.input.value;
            this.input.value = item.innerHTML.trim();
            if (this.valueInput) {
                this.valueInput.value = item.dataset.value;
            }
            if (!prevVal) {
                this.input.dispatchEvent(new CustomEvent("checkInputValidity"));
            }
        }
    }

    setSelectedByValue(value) {
        const items = this.items.filter(item => item.dataset.value === value);
        if (items.length) {
            this.setItemSelected(items[0]);
        }
    }
}

document.querySelectorAll(".js-input-select").forEach(elem => new InputSelect(elem));
